<template>
    <v-container>
      <v-row>
        <v-col cols="12" md="12" class="pa-6 text-left text-justify">
            <p class="text-h4 text--primary">
                <TextHeading :level=3>Zapytanie o szkolenia otwarte</TextHeading>
            </p>
            <div class="text-body-1 text--primary">
                Zapraszamy do uzupełnienia ponizszego formularza. Nasz konsultant przygotuje ofertę.
            </div>
            <training-contact-form type="opened"/>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TrainingContactForm from "@/modules/forms/TrainingContactForm";
  export default {
  
    components: {TrainingContactForm}
  }
  </script>